export const fill = (text, values) =>
  Object.entries(values).reduce(
    (result, [key, value]) => result.split(`{{${key}}}`).join(value),
    text || "",
  );
